
import Vue from 'vue'
import App from './App'
import router from './router'
/* eslint-disable no-new */
import es6test from './test/es6test.js'
import menu from './store/menu.js'
import pager from './store/pager.js'
import user from './store/user.js'

const emitter = require('tiny-emitter/instance')
if (window) {
  window.emitter = {
    on (msgId, callback, ctx) {
      emitter.off(msgId)
      emitter.on(msgId, callback, ctx)
    },
    emit (msgId) {
      let data = [].slice.call(arguments, 1)
      emitter.emit(msgId, ...data)
    }
  }
}
es6test.testDestructuring()
// es6test.testEnc()
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    menu: menu,
    user: user,
    pager: pager
  }
})
new Vue({
  el: '#app',
  store,
  router,
  emitter: emitter,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js